import React, { createContext, useContext } from 'react'
import { Link, useParams } from 'react-router'
import Pitch from './Pitch'
import FallbackMessage from '../components/_general/FallbackMessage'
import { FormattedMessage } from 'react-intl'
import { colors } from 'shared-ui'
import useRawState from '../hooks/useRawState'

const AnalysisContext = createContext()
export default AnalysisContext

export function RouteBasedAnalysisProvider({ children }) {

    const { analysisId } = useParams()

    return (
        <AnalysisProvider analysisId={analysisId} children={children} />
    )
}

function AnalysisProvider({ analysisId, ...props }) {
    const { data: pitch, error: pitchError } = useContext(Pitch)
    const analysisResult = useRawState(`/api/current/surface-analyses/${analysisId}`, {}, [analysisId])

    // enforce a matching pitch for the current analysis
    const matchInvalid = (
        (pitch && analysisResult?.data) && (pitch['@id'] !== analysisResult?.data?.pitch?.['@id'])
    ) || pitchError

    if (matchInvalid) {
        return (
            <div>
                <FallbackMessage>
                    <FormattedMessage id='analysisDoesntBelongWarn'
                        values={{
                            pitchId: pitch?.id ?? 'could not access id'
                        }}
                    />
                    <br />
                    <Link to='/' style={{ color: colors.main1, textDecoration: 'underline' }}>
                        <FormattedMessage id='returnToHomepage' />
                    </Link>
                </FallbackMessage>
            </div>
        )
    }

    return (
        <AnalysisContext.Provider
            value={analysisResult}
            {...props}
        />
    )
}